import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const CopyButton = ({
  value,
  label = "Copy",
  testId = "copy-button",
  toastMessage = "Copied. Paste terus into MetaTrader.",
}) => {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const el = document.createElement("textarea");
        el.value = value;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopied(true);
      toast.success(toastMessage);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      toast.error("Cannot copy automatically. Select and copy manually ya.");
    }
  };

  return (
    <button
      type="button"
      onClick={onCopy}
      data-testid={testId}
      aria-label={`${label} ${value}`}
      className="gm-btn-ghost inline-flex min-h-[40px] items-center gap-2 rounded-lg px-3 text-xs font-semibold"
    >
      {copied ? (
        <Check className="h-4 w-4" style={{ color: "var(--gm-success)" }} />
      ) : (
        <Copy className="h-4 w-4" />
      )}
      <span>{copied ? "Copied" : label}</span>
    </button>
  );
};
